import styled from 'styled-components';

export const Shippings = styled.div`
  background: white;
  min-height: 100%;
`
